import { toast } from "sonner";
import ListingCard from "./listing-list/ListingCard";

interface ListingType {
  id: string;
  title: string;
  address: string;
  price: string;
  type: string;
  status: string;
  views: number;
  inquiries: number;
  image: string;
  featured: boolean;
  boosted: boolean;
  hasUnreadMessages?: boolean;
  hasUpdates?: boolean;
}

interface ListingListViewProps {
  listings: ListingType[];
  onOpenFeaturedDialog: (id: string) => void;
  onOpenBoostDialog: (id: string) => void;
}

const ListingListView = ({
  listings,
  onOpenFeaturedDialog,
  onOpenBoostDialog,
}: ListingListViewProps) => {
  const handleNotificationToggle = (
    id: string,
    currentStatus: boolean | undefined
  ) => {
    toast.success(
      `Notifications ${currentStatus ? "disabled" : "enabled"} for this listing`
    );
    // In a real app, you would update this in your backend
  };

  const handleShareListing = (id: string, title: string) => {
    // In a real implementation, you would use the Web Share API or create a shareable link
    navigator.clipboard.writeText(`https://propertylk.com/property/${id}`);
    toast.success(`Link for "${title}" copied to clipboard`);
  };

  const handleReportIssue = (id: string) => {
    toast.success("Your report has been submitted. We'll review it shortly.");
    // In a real app, you would show a dialog to collect more information
  };

  return (
    <div className="space-y-4">
      {listings.map((property) => (
        <ListingCard
          key={property.id}
          property={property}
          onOpenFeaturedDialog={onOpenFeaturedDialog}
          onOpenBoostDialog={onOpenBoostDialog}
          onShareListing={handleShareListing}
          onReportIssue={handleReportIssue}
          onNotificationToggle={handleNotificationToggle}
        />
      ))}
    </div>
  );
};

export default ListingListView;
